import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
const before = ['Elke week uren kwijt aan het bedenken van lessen', 'Twijfel of je opbouw wel klopt', 'Geen idee wat te doen bij pijn of blessures van leerlingen', 'Steeds dezelfde reeksen herhalen', 'Stress voor elke les'];
const after = ['Kant-en-klare lessen die je meteen kunt geven', 'Professioneel opgebouwde reeksen', 'Veilige protocollen voor rug, nek, heupen en meer', 'Eindeloze variatie en inspiratie', 'Rustig en met vertrouwen lesgeven'];
export function TransformationSection() {
  return <section className="bg-brand-cream px-4 py-20 sm:px-6 md:py-28" data-id="element-177" data-mp="2j462z49ojk75">
      <div className="mx-auto max-w-[1100px]" data-id="element-178" data-mp="2e7ny84ecnlut">
        <div className="mx-auto mb-12 max-w-2xl text-center md:mb-14" data-id="element-179" data-mp="2982w5l3vuxdv">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-brand-terracotta" data-id="element-180" data-mp="295ylmkbhb04m">De rust achter elke les</p>
          <h2 className="text-4xl font-semibold tracking-[-0.025em] text-brand-text md:text-5xl" data-id="element-181" data-mp="207myis9tmkgx">Herken je dit?</h2>
        </div>
        <div className="grid items-stretch gap-5 md:grid-cols-2 md:gap-6" data-id="element-182" data-mp="fa172yfw90uc">
          <ListColumn title="ZONDER Yoga Klaar" items={before} isPositive={false} data-id="element-183" data-mp="k1j090bodx4r" />
          <ListColumn title="MET Yoga Klaar" items={after} isPositive data-id="element-184" data-mp="5cwkixi4z3d0" />
        </div>
      </div>
    </section>;
}
function ListColumn({
  title,
  items,
  isPositive
}: {
  title: string;
  items: string[];
  isPositive: boolean;
}) {
  const Icon = isPositive ? CheckCircle2 : XCircle;
  const tone = isPositive ? 'border-brand-green/20 bg-[#EEF1EA]' : 'border-brand-terracotta/20 bg-[#F8EFEB]';
  return <article className={`h-full rounded-2xl border p-6 md:p-8 ${tone}`} data-id="element-185" data-mp="p0vvo9gm4ciy">
      <div className={`mb-7 flex items-center gap-2.5 ${isPositive ? 'text-brand-green' : 'text-brand-terracotta'}`} data-id="element-186" data-mp="p0m5akrno3cq">
        <Icon className="h-5 w-5 shrink-0" strokeWidth={2} data-id="element-187" data-mp="t4bqr1d1a4tj" />
        <h3 className="text-xs font-bold uppercase tracking-[0.13em] md:text-sm" data-id="element-188" data-mp="39qbdiexusqwg">{title}</h3>
      </div>
      <ul className="space-y-5 text-brand-text" data-id="element-189" data-mp="3du9fcxekcft7">
        {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-190" data-mp="1k8xv5ij27oup">
            <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${isPositive ? 'text-brand-green' : 'text-brand-terracotta'}`} strokeWidth={2} data-id="element-191" data-mp="1fb60whuxzqnc" />
            <span className={`text-sm leading-6 md:text-[15px] ${isPositive ? 'font-medium' : ''}`} data-id="element-192" data-mp="1aiuztbogtyt7">{item}</span>
          </li>)}
      </ul>
    </article>;
}